import type { ToolUiState } from "../types/chat";

const TERMINAL_TOOL_STATES = new Set<ToolUiState>([
  "approval-responded",
  "output-available",
  "output-error",
  "output-denied",
]);

export function isTerminalToolState(state: ToolUiState | string): boolean {
  return TERMINAL_TOOL_STATES.has(state as ToolUiState);
}
